import React from "react";
import "./Contact.css";

const Contact = () => {
  return (
    <div className="contact-page">
      <h2 className="contact-title">CONTACT US</h2>

      <div className="contact-cards">
        <div className="card">
          <div className="icon">📍</div>
          <h4>Our Address</h4>
          <p>
            Address: A-117, <br/>
            Sector 72, Gautam Buddha<br/>
            Nagar, Noida, Uttar Pradesh-201301
          </p>
        </div>
        <div className="card">
          <div className="icon">🏢</div>
          <h4>Office Timing</h4>
          <p>Mon To Sat - 10.00AM-07.00PM</p>
        </div>
        <div className="card">
          <div className="icon">📧</div>
          <h4>Our Email</h4>
          <p>
            <a href="mailto:promaster.consulting@gmail.com">
              promaster.consulting<br/>@gmail.com
            </a>
          </p>
        </div>
        <div className="card">
          <div className="icon">📞</div>
          <h4>Our Phone</h4>
          <p>
            <a href="tel:+910000000000">+91 70210520017</a>
          </p>
        </div>
      </div>

      <div className="contact-form">
        <h3>Send Us a Message</h3>
        <form
        className="contact-form"
       action="https://formsubmit.co/promaster.consulting@gmail.com"
  method="POST"
>
  <input type="text" name="name" placeholder="Name" required />
  <input type="email" name="email" placeholder="Email" required />
  <input type="tel" name="mobile" placeholder="Mobile No." required />
  <textarea name="message" placeholder="Your Message" rows="4" required></textarea>

  {/* Optional hidden inputs
  <input type="hidden" name="_captcha" value="false" />
  <input type="hidden" name="_next" value="https://yourwebsite.com/thankyou" /> */}

  <button type="submit">Send Message</button>
</form>

      </div>
    </div>
  );
};

export default Contact;
